import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SkewButton from "../components/SkewButton";
import TerminalWindow from "../components/TerminalWindow";
import NeonCard from "../components/NeonCard";
import SectionHeading from "../components/SectionHeading";
import Marquee from "../components/Marquee";

const PUB = process.env.PUBLIC_URL || "";

const TICKER_ITEMS = [
  "BOMBS ARE DROPPING",
  "WELCOME TO 4.0",
  "NORTH KOREA HAS BOMBS // BUT HAVE THEY HEARD MIKE?",
  "THE BALABUSTA GETS DOWN",
  "WE NO ARE NO NICE GUY",
  "CACTUS SPOTTED IN THE WILD",
  "THE GROOVES GO ON FOREVER",
  "NEW PANTS DETECTED ON INSTAGRAM",
  "MINKINS!! (DADADADADA)",
  "NELLIE KANE INCOMING",
];

const POLL = [
  { name: "Shoes", pct: 41, votes: 16, color: "#FF00FF" },
  { name: "Astronaut", pct: 36, votes: 14, color: "#00FFFF" },
  { name: "Scarf", pct: 23, votes: 9, color: "#FF9900" },
];

const PORTALS = [
  {
    to: "/mission",
    title: "MISSION STATEMENT",
    blurb: "Why we follow a middle-aged grey-haired man around like he is Beyoncé.",
    code: "[01]",
    accent: { top: "magenta", side: "cyan" },
  },
  {
    to: "/newsletter",
    title: "NEWSLETTER",
    blurb: "Funky pant intel + cosmic whisperings, dispatched to your inbox.",
    code: "[02]",
    accent: { top: "cyan", side: "magenta" },
  },
  {
    to: "/team",
    title: "C-LEVEL EXECS",
    blurb: "The Phunky Balabusta and friends. They make the rules.",
    code: "[03]",
    accent: { top: "orange", side: "magenta" },
  },
  {
    to: "/scene",
    title: "ENTER THE VOID",
    blurb: "A 3D fan-club secret room. Drag to look around.",
    code: "[04]",
    accent: { top: "lime", side: "lime" },
    voidish: true,
  },
];

const SET_ACCENTS = ["#FF00FF", "#00FFFF", "#9FFF00", "#FF9900"];

function SetlistSection() {
  const [state, setState] = useState({ status: "loading", show: null });

  useEffect(() => {
    let alive = true;
    fetch("/api/setlist")
      .then(async (res) => {
        if (!res.ok) throw new Error(`http_${res.status}`);
        return res.json();
      })
      .then((show) => {
        if (!alive) return;
        if (!show?.sets?.length) {
          setState({ status: "empty", show: null });
          return;
        }
        setState({ status: "ok", show });
      })
      .catch((err) => {
        if (!alive) return;
        console.error("[setlist]", err);
        setState({ status: "error", show: null });
      });
    return () => {
      alive = false;
    };
  }, []);

  if (state.status === "error" || state.status === "empty") return null;

  const show = state.show;
  const bannerLine =
    state.status === "ok"
      ? `SETLIST: ${show.artist.toUpperCase()}, ${show.date}`
      : "SETLIST: FETCHING…";

  return (
    <section className="relative mx-auto max-w-5xl px-4 pb-24 sm:px-6 sm:pb-32 lg:px-8">
      <SectionHeading
        eyebrow="// transmission live"
        title="Latest setlist"
        align="left"
        accent="lime"
      />
      <div className="mt-12">
        <TerminalWindow
          title="setlist://livephish.feed"
          status="LIVE ▸ AUTO-REFRESH 10m"
          accent="magenta"
        >
          <div
            className="relative overflow-hidden px-6 py-5 sm:px-8"
            style={{
              background:
                "linear-gradient(90deg, #FF00FF 0%, #B100FF 55%, #6A00FF 100%)",
            }}
          >
            <div
              className="absolute inset-0 opacity-40 mix-blend-overlay"
              style={{
                background:
                  "repeating-linear-gradient(0deg, rgba(255,255,255,0.18) 0 1px, transparent 1px 4px)",
              }}
            />
            <p className="relative font-display text-base font-black uppercase tracking-[0.18em] text-white drop-shadow-[0_0_8px_rgba(0,0,0,0.55)] sm:text-xl">
              {bannerLine}
              {state.status === "loading" && (
                <span className="ml-2 animate-blink-cursor">█</span>
              )}
            </p>
          </div>

          {state.status === "loading" ? (
            <div className="px-6 py-10 font-mono text-sm uppercase tracking-[0.3em] text-mgfc-fg/55 sm:px-8">
              <span className="text-mgfc-cyan">&gt;</span> fetching latest from
              livephish
              <span className="ml-1 animate-blink-cursor">█</span>
            </div>
          ) : (
            <>
              <div className="px-6 pt-6 sm:px-8">
                <p className="font-mono text-sm uppercase tracking-[0.3em] text-mgfc-cyan">
                  <span className="text-mgfc-magenta">▸</span>{" "}
                  {show.venueName}
                  {show.venueCity ? ` — ${show.venueCity}` : ""}
                  {show.venueState ? `, ${show.venueState}` : ""}
                </p>
                {show.totalRunTime && (
                  <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.35em] text-mgfc-fg/45">
                    total run time {show.totalRunTime}
                  </p>
                )}
              </div>

              <ul className="space-y-4 px-6 pb-6 pt-6 sm:px-8 sm:pb-8 sm:pt-8">
                {show.sets.map((set, i) => {
                  const accent = SET_ACCENTS[i % SET_ACCENTS.length];
                  return (
                    <li
                      key={set.name + i}
                      className="font-mono text-sm leading-relaxed text-mgfc-fg/85 sm:text-base"
                    >
                      <span
                        className="font-bold uppercase tracking-[0.25em]"
                        style={{
                          color: accent,
                          textShadow: `0 0 10px ${accent}66`,
                        }}
                      >
                        {set.name}:
                      </span>{" "}
                      {set.songs.map((s, j) => (
                        <span key={j}>
                          <span className="text-mgfc-fg">{s.title}</span>
                          {s.runTime && (
                            <span className="text-mgfc-fg/40">
                              {" "}
                              ({s.runTime})
                            </span>
                          )}
                          {j < set.songs.length - 1 && (
                            <span className="text-mgfc-fg/40">, </span>
                          )}
                        </span>
                      ))}
                    </li>
                  );
                })}
              </ul>
            </>
          )}

          <div className="border-t border-mgfc-magenta/40 px-6 py-3 sm:px-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-mgfc-fg/50">
              <span className="text-mgfc-magenta">//</span> updates as soon as
              the release lands on livephish{" "}
              {show?.sourceUrl ? (
                <a
                  href={show.sourceUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-mgfc-cyan hover:text-glow-cyan"
                >
                  ↗ open release
                </a>
              ) : null}
            </p>
          </div>
        </TerminalWindow>
      </div>
    </section>
  );
}

export default function HomePage() {
  return (
    <>
      {/* HERO ----------------------------------------------------------------- */}
      <section className="relative isolate overflow-hidden">
        <div
          className="absolute inset-0 -z-10 bg-cover bg-center duotone-magenta-cyan"
          style={{
            backgroundImage: `url(${PUB}/uploads/2018/08/Cdd_7OHW4AARjTP.jpg)`,
          }}
        />
        <div className="absolute inset-0 -z-10 duotone-magenta-cyan-overlay" />
        <div
          className="absolute inset-0 -z-10"
          style={{
            background:
              "linear-gradient(180deg, rgba(9,0,20,0.65) 0%, rgba(9,0,20,0.55) 40%, #090014 100%)",
          }}
        />

        <div className="mx-auto max-w-7xl px-4 pt-16 pb-24 sm:px-6 lg:px-8 sm:pt-24 sm:pb-32">
          <div className="flex flex-col items-center text-center">
            <p className="font-mono text-[11px] uppercase tracking-[0.5em] text-mgfc-cyan">
              <span className="opacity-60">/// </span>
              EST. 2018 // OFFICIAL // FAN-CLUB
            </p>

            <img
              src={`${PUB}/uploads/2018/10/mike-logo-2.png`}
              alt="MGFC chrome wordmark"
              className="mt-8 w-full max-w-[34rem] drop-shadow-[0_0_30px_rgba(159,255,0,0.5)]"
              draggable={false}
            />

            <h1 className="mt-10 font-display text-5xl font-black uppercase leading-[0.92] tracking-tight sm:text-7xl md:text-8xl lg:text-9xl">
              <span className="block gradient-text drop-shadow-[0_0_30px_rgba(255,0,255,0.5)]">
                Mike Gordon
              </span>
              <span className="block gradient-text-mike">Fan Club</span>
            </h1>

            <p className="mt-6 max-w-2xl font-mono text-sm uppercase tracking-[0.4em] text-mgfc-fg/75 sm:text-base">
              ◢ We all love Mike ◣
            </p>

            <div className="mt-12 flex flex-wrap items-center justify-center gap-5">
              <SkewButton to="/scene" variant="lime">
                ▸ Drop into the void
              </SkewButton>
              <SkewButton to="/mission" variant="magenta">
                ▸ Read the manifesto
              </SkewButton>
              <Link
                to="/newsletter"
                className="font-mono text-xs uppercase tracking-[0.35em] text-mgfc-cyan hover:text-glow-cyan"
              >
                or sign up for transmissions →
              </Link>
            </div>

            <div className="mt-16 flex flex-wrap items-center justify-center gap-x-10 gap-y-2 font-mono text-[11px] uppercase tracking-[0.35em] text-mgfc-fg/40">
              <span><span className="text-mgfc-cyan">▸</span> 4.5B yrs of earth</span>
              <span><span className="text-mgfc-magenta">▸</span> 100 yrs of you</span>
              <span><span className="text-mgfc-lime">▸</span> ∞ minutes of mike</span>
            </div>
          </div>
        </div>
      </section>

      {/* TICKER --------------------------------------------------------------- */}
      <Marquee items={TICKER_ITEMS} />

      {/* WELCOME -------------------------------------------------------------- */}
      <section className="relative mx-auto max-w-5xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
        <SectionHeading
          eyebrow="// transmission 0001"
          title="You may call him Cactus"
          align="center"
          accent="magenta"
        />
        <div className="mt-12">
          <TerminalWindow title="manifesto.txt" status="OPEN ▸ READ-ONLY">
            <div className="space-y-5 p-6 font-mono text-base leading-relaxed text-mgfc-fg/85 sm:p-8 sm:text-lg">
              <p>
                <span className="mr-2 text-mgfc-cyan">&gt;</span>
                You may call him Cactus. You may call him Gordo. You may simply
                call him Mike. You may be chasing Minkin. You may be chasing
                Weigh. You're probably chasing any song that sounds so estrange.
              </p>
              <p>
                <span className="mr-2 text-mgfc-cyan">&gt;</span>
                You may be wondering how you got here, but rest assured, it's
                for good and funky reason. Welcome to the official{" "}
                <span className="text-mgfc-lime">Mike Gordon Fan Club</span>. We
                are just as happy you're here as Mike is when… well, you know
                Mike rarely <em className="not-italic text-mgfc-magenta">appears</em> happy.
                But that's what we love about him.
              </p>
              <p>
                <span className="mr-2 text-mgfc-cyan">&gt;</span>
                The Mike Gordon Fan Club was started by people just like{" "}
                <span className="text-mgfc-cyan">YOU</span> &mdash; phans who
                spend their shows listening to those grooves, those bombs, those
                ever-lasting sploofs. It seems to us that those grooves can go
                on forever and never (laugh and laugh and) fall apart.
              </p>
              <p className="text-mgfc-fg/60">
                <span className="mr-2 text-mgfc-magenta">&gt;</span>
                <span className="animate-blink-cursor">█</span>
              </p>
            </div>
          </TerminalWindow>
        </div>
      </section>

      {/* PORTALS -------------------------------------------------------------- */}
      <section className="relative mx-auto max-w-7xl px-4 pb-24 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="// pick your destination"
          title="Four portals, one Cactus"
          align="left"
          accent="cyan"
        />
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {PORTALS.map((p) => (
            <NeonCard
              key={p.to}
              to={p.to}
              topAccent={p.accent.top}
              sideAccent={p.accent.side}
              className="h-full"
            >
              <div className="flex h-full flex-col">
                <span
                  className="font-mono text-[11px] uppercase tracking-[0.4em]"
                  style={{
                    color:
                      p.accent.top === "magenta"
                        ? "#FF00FF"
                        : p.accent.top === "lime"
                          ? "#9FFF00"
                          : p.accent.top === "orange"
                            ? "#FF9900"
                            : "#00FFFF",
                  }}
                >
                  {p.code}
                </span>
                <h3
                  className={[
                    "mt-6 font-display text-2xl font-black uppercase leading-tight tracking-tight",
                    p.voidish
                      ? "text-mgfc-lime text-glow-lime"
                      : "text-mgfc-cyan text-glow-cyan",
                  ].join(" ")}
                >
                  {p.title}
                </h3>
                <p className="mt-3 font-mono text-sm leading-relaxed text-mgfc-fg/65">
                  {p.blurb}
                </p>
                <span
                  className={[
                    "mt-auto pt-8 font-mono text-xs uppercase tracking-[0.4em] transition-transform duration-200",
                    "group-hover:translate-x-1",
                    p.voidish ? "text-mgfc-lime" : "text-mgfc-cyan",
                  ].join(" ")}
                >
                  ENTER ▸▸
                </span>
              </div>
            </NeonCard>
          ))}
        </div>
      </section>

      {/* SETLIST -------------------------------------------------------------- */}
      <SetlistSection />

      {/* POLL ----------------------------------------------------------------- */}
      <section className="relative mx-auto max-w-4xl px-4 pb-24 sm:px-6 sm:pb-32 lg:px-8">
        <TerminalWindow
          title="poll://favorite-cactus-look"
          status="LIVE ▸ TOTAL VOTERS: 39"
          accent="orange"
        >
          <div className="space-y-6 p-6 sm:p-10">
            <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-end">
              <div>
                <p className="font-mono text-xs uppercase tracking-[0.35em] text-mgfc-orange">
                  // QUESTION 01
                </p>
                <h3 className="mt-2 font-display text-3xl font-black uppercase leading-tight text-mgfc-fg sm:text-4xl">
                  What is your favorite{" "}
                  <span className="gradient-text">Cactus look?</span>
                </h3>
              </div>
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-mgfc-fg/40">
                Updated monthly &mdash; check back to weigh in
              </span>
            </div>

            <ul className="space-y-5">
              {POLL.map((p) => (
                <li key={p.name}>
                  <div className="flex items-baseline justify-between gap-4 font-mono text-sm uppercase tracking-[0.25em]">
                    <span className="text-mgfc-fg">{p.name}</span>
                    <span className="text-mgfc-fg/60">
                      {p.pct}% &middot; {p.votes} votes
                    </span>
                  </div>
                  <div className="mt-2 h-2 w-full bg-mgfc-border/60">
                    <div
                      className="h-full transition-all duration-500"
                      style={{
                        width: `${p.pct}%`,
                        background: p.color,
                        boxShadow: `0 0 12px ${p.color}`,
                      }}
                    />
                  </div>
                </li>
              ))}
            </ul>

            <p className="border-t border-mgfc-border/60 pt-4 font-mono text-xs uppercase tracking-[0.3em] text-mgfc-fg/45">
              ⚿ Polling apparatus on holiday. Stay groovy.
            </p>
          </div>
        </TerminalWindow>
      </section>

      {/* CTA ----------------------------------------------------------------- */}
      <section className="relative mx-auto max-w-5xl px-4 pb-24 sm:px-6 sm:pb-32 lg:px-8">
        <div className="relative border-2 border-mgfc-lime/50 bg-mgfc-bg/70 p-10 text-center shadow-[0_0_50px_rgba(159,255,0,0.18)] sm:p-16">
          <div
            className="absolute inset-x-0 top-0 h-[2px]"
            style={{
              background:
                "linear-gradient(90deg, transparent, #9FFF00, transparent)",
            }}
          />
          <p className="font-mono text-xs uppercase tracking-[0.4em] text-mgfc-lime">
            // INITIATE.HANDSHAKE()
          </p>
          <h2 className="mt-4 font-display text-3xl font-black uppercase leading-tight tracking-tight sm:text-5xl">
            <span className="gradient-text-mike">Make yourself at home</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl font-mono text-base leading-relaxed text-mgfc-fg/80 sm:text-lg">
            Eat some meat. Weigh your options. Share in the groove. Be weird.
            Have fun. <span className="text-mgfc-cyan">Do as Mike would do.</span>
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <SkewButton to="/newsletter" variant="lime">
              ▸ Subscribe
            </SkewButton>
            <SkewButton to="/team">▸ Meet the C-suite</SkewButton>
          </div>
        </div>
      </section>
    </>
  );
}
